import { render } from "./ActivityTemplatePdf.vue?vue&type=template&id=22f4646a"
import script from "./ActivityTemplatePdf.vue?vue&type=script&lang=js"
export * from "./ActivityTemplatePdf.vue?vue&type=script&lang=js"

import "./ActivityTemplatePdf.vue?vue&type=style&index=0&id=22f4646a&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__